// extracted by mini-css-extract-plugin
export var infoItem = "_un-2";
export var title = "_un-0";
export var value = "_un-1";